module.exports = __webpack_public_path__ + "img/j.363d2685.jpg";